var map = {
	"./Career/Career.jpg": 603,
	"./Enterprise/enterprise.jpg": 604,
	"./KDR-WHITE.png": 36,
	"./Testimonial/cost.png": 432,
	"./Testimonial/quality.png": 433,
	"./Testimonial/refer.png": 434,
	"./Testimonial/schedule.png": 435,
	"./Testimonial/star.png": 259,
	"./Testimonial/testimonial.png": 260,
	"./about/appfutura.png": 605,
	"./about/businessofapps.png": 606,
	"./about/clutch.png": 607,
	"./about/extract.png": 608,
	"./about/itfirms.png": 609,
	"./about/top5.png": 610,
	"./avatar-bg.png": 347,
	"./becomePartner/becomePartner.png": 611,
	"./blockchain/Ethereum.svg": 612,
	"./blockchain/NXT.png": 613,
	"./blockchain/exonum.png": 614,
	"./blockchain/hyperledger.png": 615,
	"./blockchain/multichain.png": 616,
	"./blockchain/parity.jpg": 617,
	"./blockchain/parity.png": 618,
	"./blockchain/r3.png": 619,
	"./clutch.png": 348,
	"./contactPage/India.png": 620,
	"./contactPage/contact-banner.jpg": 436,
	"./contactPage/contactbg-india.jpg": 621,
	"./contactUs.svg": 622,
	"./footerClientLogos/Telangana.PNG": 623,
	"./footerClientLogos/airtel.png": 422,
	"./footerClientLogos/audi.svg": 624,
	"./footerClientLogos/facebook.png": 423,
	"./footerClientLogos/footer-client-logo2.png": 424,
	"./footerClientLogos/footer-client-logo4.png": 425,
	"./footerClientLogos/footer-client-logo5.png": 426,
	"./footerClientLogos/footer-clutch-logo.png": 427,
	"./footerClientLogos/footer-top-company-logo.png": 428,
	"./footerClientLogos/googlepartner.png": 429,
	"./footerClientLogos/guinness.svg": 625,
	"./footerClientLogos/jaguar.svg": 626,
	"./footerClientLogos/ms.png": 430,
	"./footerClientLogos/softwareworld-badge.png": 431,
	"./footerClientLogos/universal.svg": 627,
	"./gfaward.png": 349,
	"./heroSectionBackground.png": 628,
	"./heroSectionImage2.svg": 629,
	"./india.png": 437,
	"./india.svg": 258,
	"./pageNotFound/404.svg": 438,
	"./people.jpg": 420,
	"./portfolios/android.png": 261,
	"./portfolios/divineprop.png": 262,
	"./portfolios/ecomm.png": 263,
	"./portfolios/feedbellie.png": 264,
	"./portfolios/ios.png": 265,
	"./portfolios/kdr.png": 266,
	"./portfolios/kdr/1.png": 267,
	"./portfolios/kdr/2.png": 268,
	"./portfolios/kdr/3.png": 269,
	"./portfolios/kdr/4.png": 270,
	"./portfolios/kdr/5.png": 271,
	"./portfolios/kdr/VanamaliLogo.png": 272,
	"./portfolios/kdr/d1.png": 273,
	"./portfolios/kdr/divinelogo.png": 274,
	"./portfolios/kdr/ec.png": 275,
	"./portfolios/kdr/ecom.png": 276,
	"./portfolios/kdr/ecomlogo.png": 277,
	"./portfolios/kdr/f1.png": 278,
	"./portfolios/kdr/f10.png": 279,
	"./portfolios/kdr/f2.png": 280,
	"./portfolios/kdr/f4.png": 281,
	"./portfolios/kdr/f8.png": 282,
	"./portfolios/kdr/fb.png": 283,
	"./portfolios/kdr/fb1.png": 284,
	"./portfolios/kdr/fb2.png": 285,
	"./portfolios/kdr/fb3.png": 286,
	"./portfolios/kdr/fb4.png": 287,
	"./portfolios/kdr/fb5.png": 288,
	"./portfolios/kdr/kdr.png": 289,
	"./portfolios/kdr/m1.png": 290,
	"./portfolios/kdr/m2.png": 291,
	"./portfolios/kdr/m3.png": 292,
	"./portfolios/kdr/m5.png": 293,
	"./portfolios/kdr/m6.png": 294,
	"./portfolios/kdr/m7.png": 295,
	"./portfolios/kdr/mananagaram.png": 296,
	"./portfolios/kdr/n1.png": 297,
	"./portfolios/kdr/n2.png": 298,
	"./portfolios/kdr/n3.png": 299,
	"./portfolios/kdr/n4.png": 300,
	"./portfolios/kdr/n5.png": 301,
	"./portfolios/kdr/nalgonda.png": 302,
	"./portfolios/kdr/s1.png": 303,
	"./portfolios/kdr/s2.png": 304,
	"./portfolios/kdr/s3.png": 305,
	"./portfolios/kdr/s4.png": 306,
	"./portfolios/kdr/s5.png": 307,
	"./portfolios/kdr/snfoods.png": 308,
	"./portfolios/kdr/srpt.png": 309,
	"./portfolios/kdr/startcareer.png": 310,
	"./portfolios/kdr/v1.png": 311,
	"./portfolios/kdr/w1.png": 312,
	"./portfolios/kdr/w2.png": 313,
	"./portfolios/kdr/w3.png": 314,
	"./portfolios/kdr/w4.png": 315,
	"./portfolios/kdr/w5.png": 316,
	"./portfolios/kdr/wapp.png": 317,
	"./portfolios/mana.png": 318,
	"./portfolios/nalgonda.png": 319,
	"./portfolios/nalgov.png": 320,
	"./portfolios/quote.svg": 49,
	"./portfolios/sc.png": 321,
	"./portfolios/send.svg": 322,
	"./portfolios/snfood.png": 323,
	"./portfolios/testScreenShot.png": 324,
	"./portfolios/vanamali.png": 325,
	"./portfolios/web.png": 326,
	"./portfolios/webecomm.png": 327,
	"./portfolios/wordsapp.png": 328,
	"./portfolios/wordsapp.webp": 439,
	"./resourcesPage/meet.png": 440,
	"./resourcesPage/resources.jpg": 441,
	"./services/Icons/php.png": 630,
	"./services/Mobile/android.png": 442,
	"./services/Mobile/crossp.png": 443,
	"./services/Mobile/flutter.png": 444,
	"./services/Mobile/flutter/cross-platform.svg": 445,
	"./services/Mobile/flutter/hire.svg": 446,
	"./services/Mobile/flutter/industry-solutions.svg": 447,
	"./services/Mobile/flutter/server-maintenance.svg": 448,
	"./services/Mobile/ionic.png": 449,
	"./services/Mobile/ionic/ionic.svg": 450,
	"./services/Mobile/ios.png": 451,
	"./services/Mobile/mobileappdev.png": 452,
	"./services/Mobile/pwa/offline-support.svg": 453,
	"./services/Mobile/pwa/progressive.svg": 454,
	"./services/Mobile/pwa/retention.svg": 455,
	"./services/Mobile/pwa/sharable.svg": 456,
	"./services/Mobile/pwa/user-friendly.svg": 457,
	"./services/Mobile/react-native/app-migration.svg": 458,
	"./services/Mobile/react-native/consulting.svg": 459,
	"./services/Mobile/react-native/customization-service.svg": 460,
	"./services/Mobile/react-native/mobile-app-development.svg": 461,
	"./services/Mobile/react-native/service-maintenance.svg": 462,
	"./services/Mobile/react.png": 463,
	"./services/Web/Dashboard.png": 631,
	"./services/Web/angular.png": 632,
	"./services/Web/dotnet.png": 633,
	"./services/Web/ecomm.png": 634,
	"./services/Web/java.png": 635,
	"./services/Web/magento.png": 636,
	"./services/Web/nodejs.png": 637,
	"./services/Web/php.png": 638,
	"./services/Web/reactjs.png": 639,
	"./services/Web/uiux.png": 640,
	"./services/Web/web.png": 464,
	"./services/Web/webdev.png": 641,
	"./services/Web/wp.png": 642,
	"./services/emergingTech/Dev.jpg": 465,
	"./services/emergingTech/Team.jpg": 466,
	"./services/emergingTech/aboutus.jpg": 467,
	"./services/emergingTech/app.png": 468,
	"./services/emergingTech/awards.jpg": 469,
	"./services/emergingTech/clients.jpg": 470,
	"./services/emergingTech/cloudcom.png": 471,
	"./services/emergingTech/consulting.png": 472,
	"./services/emergingTech/development.jpg": 473,
	"./services/emergingTech/devop.png": 474,
	"./services/emergingTech/devops.png": 475,
	"./services/emergingTech/disclaimer.png": 476,
	"./services/emergingTech/engagementmodel.jpg": 477,
	"./services/emergingTech/erp.png": 478,
	"./services/emergingTech/hireteam.png": 479,
	"./services/emergingTech/iot.png": 480,
	"./services/emergingTech/itcons.png": 481,
	"./services/emergingTech/open-source.png": 482,
	"./services/emergingTech/opensource.png": 483,
	"./services/emergingTech/partnership.jpg": 484,
	"./services/emergingTech/press.png": 485,
	"./services/emergingTech/privacypolicy.png": 486,
	"./services/emergingTech/produceng.png": 487,
	"./services/emergingTech/projectmanagement.jpg": 488,
	"./services/emergingTech/pwa.png": 489,
	"./services/emergingTech/qa.jpg": 490,
	"./services/emergingTech/qa.png": 491,
	"./services/emergingTech/qatesting.jpg": 492,
	"./services/emergingTech/sdlc.png": 493,
	"./services/emergingTech/support.png": 494,
	"./services/emergingTech/wearable.png": 495,
	"./services/emergingTech/webecomm.png": 496,
	"./services/wearable.png": 643,
	"./singleQuote.svg": 419,
	"./sme.png": 644,
	"./softwareworld.png": 645,
	"./solutions/industries/REP.png": 497,
	"./solutions/industries/bfsi.png": 498,
	"./solutions/industries/ecomm.png": 499,
	"./solutions/industries/el.png": 500,
	"./solutions/industries/evnt.png": 501,
	"./solutions/industries/fnb.png": 502,
	"./solutions/industries/gaming.png": 503,
	"./solutions/industries/health.png": 504,
	"./solutions/industries/media.png": 505,
	"./solutions/industries/real-estate.jpg": 506,
	"./solutions/industries/sn.png": 507,
	"./solutions/industries/th.png": 508,
	"./solutions/industries/trans.png": 509,
	"./solutions/solution/ai.png": 329,
	"./solutions/solution/app.png": 330,
	"./solutions/solution/ar.png": 331,
	"./solutions/solution/augmented-reality-hololens.png": 332,
	"./solutions/solution/blockchain.jpg": 333,
	"./solutions/solution/d1.png": 334,
	"./solutions/solution/d10.png": 335,
	"./solutions/solution/d11.png": 336,
	"./solutions/solution/d2.png": 337,
	"./solutions/solution/d3.png": 338,
	"./solutions/solution/d4.png": 339,
	"./solutions/solution/d5.png": 340,
	"./solutions/solution/d6.png": 341,
	"./solutions/solution/d7.png": 342,
	"./solutions/solution/d8.png": 343,
	"./solutions/solution/d9.png": 344,
	"./solutions/solution/logos/4glte.png": 50,
	"./solutions/solution/logos/Autoit.png": 51,
	"./solutions/solution/logos/Java_ee7.png": 52,
	"./solutions/solution/logos/Opencart.png": 53,
	"./solutions/solution/logos/Volley.png": 54,
	"./solutions/solution/logos/Zeplin.png": 55,
	"./solutions/solution/logos/ajax.png": 56,
	"./solutions/solution/logos/amqp.png": 57,
	"./solutions/solution/logos/android-launcher.png": 58,
	"./solutions/solution/logos/android-tv.png": 59,
	"./solutions/solution/logos/android.png": 60,
	"./solutions/solution/logos/android1.png": 61,
	"./solutions/solution/logos/android_gear.png": 62,
	"./solutions/solution/logos/android_gradle.png": 63,
	"./solutions/solution/logos/android_nougat.png": 64,
	"./solutions/solution/logos/android_studio.png": 65,
	"./solutions/solution/logos/androidview_animations.png": 66,
	"./solutions/solution/logos/anfetworking.png": 67,
	"./solutions/solution/logos/angularjs.png": 68,
	"./solutions/solution/logos/anndroid_wear.png": 69,
	"./solutions/solution/logos/api_development.png": 70,
	"./solutions/solution/logos/apple-3d-touch.png": 71,
	"./solutions/solution/logos/apple-callkit.png": 72,
	"./solutions/solution/logos/apple-healthkit.png": 73,
	"./solutions/solution/logos/apple-watch.png": 74,
	"./solutions/solution/logos/apple-watch1.png": 75,
	"./solutions/solution/logos/apple.jpg": 76,
	"./solutions/solution/logos/apple.png": 77,
	"./solutions/solution/logos/appletv.png": 78,
	"./solutions/solution/logos/aspnet.png": 79,
	"./solutions/solution/logos/augmented_reality.png": 80,
	"./solutions/solution/logos/aws.png": 81,
	"./solutions/solution/logos/bl_deviceintegration.png": 82,
	"./solutions/solution/logos/bluetooth.png": 83,
	"./solutions/solution/logos/bootstrap.png": 84,
	"./solutions/solution/logos/bugzilla.png": 85,
	"./solutions/solution/logos/c-sharp.png": 86,
	"./solutions/solution/logos/cake-php.png": 87,
	"./solutions/solution/logos/cloudsync.png": 88,
	"./solutions/solution/logos/cms_solution_integration.png": 89,
	"./solutions/solution/logos/coap.png": 90,
	"./solutions/solution/logos/cocoa-touch.png": 91,
	"./solutions/solution/logos/cocoapods.png": 92,
	"./solutions/solution/logos/codeigniter.png": 93,
	"./solutions/solution/logos/comprehensive_order_management.png": 94,
	"./solutions/solution/logos/conversion_optimization.png": 95,
	"./solutions/solution/logos/core_data.png": 96,
	"./solutions/solution/logos/coreldrow.png": 97,
	"./solutions/solution/logos/css.png": 98,
	"./solutions/solution/logos/custom_page_development.png": 99,
	"./solutions/solution/logos/customized_eCommerce-_site_development.png": 100,
	"./solutions/solution/logos/dagger2.png": 101,
	"./solutions/solution/logos/desired_payment_gateway_options.png": 102,
	"./solutions/solution/logos/dot_net_core.png": 103,
	"./solutions/solution/logos/dot_net_yet.png": 104,
	"./solutions/solution/logos/dreamweaver.png": 105,
	"./solutions/solution/logos/drupal.png": 106,
	"./solutions/solution/logos/eclipse.png": 107,
	"./solutions/solution/logos/ember.png": 108,
	"./solutions/solution/logos/ethernet.png": 109,
	"./solutions/solution/logos/extensionp_plugin_integration (1).png": 110,
	"./solutions/solution/logos/extensionp_plugin_integration.png": 111,
	"./solutions/solution/logos/fitbit.png": 112,
	"./solutions/solution/logos/fitness_tracker.png": 113,
	"./solutions/solution/logos/flutter.png": 114,
	"./solutions/solution/logos/foundation.png": 115,
	"./solutions/solution/logos/git.png": 116,
	"./solutions/solution/logos/glide.png": 117,
	"./solutions/solution/logos/google_glassiWatch.png": 118,
	"./solutions/solution/logos/gps_watch.png": 119,
	"./solutions/solution/logos/gridsystems.png": 120,
	"./solutions/solution/logos/gsm_network.png": 121,
	"./solutions/solution/logos/hibernate5.2.5.png": 122,
	"./solutions/solution/logos/html-5.png": 123,
	"./solutions/solution/logos/html.png": 124,
	"./solutions/solution/logos/html5_boilerplarte.png": 125,
	"./solutions/solution/logos/iMessage.png": 126,
	"./solutions/solution/logos/ibeacon-device.png": 127,
	"./solutions/solution/logos/illustrator.png": 128,
	"./solutions/solution/logos/in-app-purchase.png": 129,
	"./solutions/solution/logos/in_app_purchases.png": 130,
	"./solutions/solution/logos/indesign.png": 131,
	"./solutions/solution/logos/intelliJ.png": 132,
	"./solutions/solution/logos/ionic.png": 133,
	"./solutions/solution/logos/ios.png": 134,
	"./solutions/solution/logos/jQuery.png": 135,
	"./solutions/solution/logos/java.png": 136,
	"./solutions/solution/logos/jdbc.png": 137,
	"./solutions/solution/logos/jenkins.png": 138,
	"./solutions/solution/logos/jira.png": 139,
	"./solutions/solution/logos/jmeter.png": 140,
	"./solutions/solution/logos/joomla.png": 141,
	"./solutions/solution/logos/jquerymobile.png": 142,
	"./solutions/solution/logos/js.png": 143,
	"./solutions/solution/logos/json.png": 144,
	"./solutions/solution/logos/kendo.png": 145,
	"./solutions/solution/logos/laravel.png": 146,
	"./solutions/solution/logos/less.png": 147,
	"./solutions/solution/logos/magento-logo1.png": 148,
	"./solutions/solution/logos/magento-logo10.png": 149,
	"./solutions/solution/logos/magento-logo11.png": 150,
	"./solutions/solution/logos/magento-logo2.png": 151,
	"./solutions/solution/logos/magento-logo3.png": 152,
	"./solutions/solution/logos/magento-logo4.png": 153,
	"./solutions/solution/logos/magento-logo5.png": 154,
	"./solutions/solution/logos/magento-logo6.png": 155,
	"./solutions/solution/logos/magento-logo7.png": 156,
	"./solutions/solution/logos/magento-logo8.png": 157,
	"./solutions/solution/logos/magento-logo9.png": 158,
	"./solutions/solution/logos/magento.png": 159,
	"./solutions/solution/logos/mantis.png": 160,
	"./solutions/solution/logos/material_design.png": 161,
	"./solutions/solution/logos/maven.png": 162,
	"./solutions/solution/logos/migration_to_shopify.png": 163,
	"./solutions/solution/logos/mobile_commerce.png": 164,
	"./solutions/solution/logos/mongo_db.png": 165,
	"./solutions/solution/logos/mqtt.png": 166,
	"./solutions/solution/logos/multi_store_multi_lingual_setup.png": 167,
	"./solutions/solution/logos/mvc_framework.png": 168,
	"./solutions/solution/logos/mysql.png": 169,
	"./solutions/solution/logos/mysql5x.png": 170,
	"./solutions/solution/logos/netbeans.png": 171,
	"./solutions/solution/logos/netframework4.5.png": 172,
	"./solutions/solution/logos/nodejs.png": 173,
	"./solutions/solution/logos/objective-c.png": 174,
	"./solutions/solution/logos/omni_channel_planning.png": 175,
	"./solutions/solution/logos/online_shopping_cart_management.png": 176,
	"./solutions/solution/logos/open_source.png": 177,
	"./solutions/solution/logos/opencart-module-integration.png": 178,
	"./solutions/solution/logos/opnecart_customized_template_design.png": 179,
	"./solutions/solution/logos/payment_gateway_integration.png": 180,
	"./solutions/solution/logos/personalizedstorefront.png": 181,
	"./solutions/solution/logos/phonegap.png": 182,
	"./solutions/solution/logos/photoshop.png": 183,
	"./solutions/solution/logos/php.png": 184,
	"./solutions/solution/logos/php4x.png": 185,
	"./solutions/solution/logos/php5x.png": 186,
	"./solutions/solution/logos/php7x.png": 187,
	"./solutions/solution/logos/powerful_store_management.png": 188,
	"./solutions/solution/logos/prototypejs.png": 189,
	"./solutions/solution/logos/push_notifications.png": 190,
	"./solutions/solution/logos/react_native.png": 191,
	"./solutions/solution/logos/realm.png": 192,
	"./solutions/solution/logos/rest.png": 193,
	"./solutions/solution/logos/retrofit2.png": 194,
	"./solutions/solution/logos/saas.png": 195,
	"./solutions/solution/logos/samsung_gear.png": 196,
	"./solutions/solution/logos/scalable_application.png": 197,
	"./solutions/solution/logos/selenium_forweb.png": 198,
	"./solutions/solution/logos/selenium_with_appium.png": 199,
	"./solutions/solution/logos/sencha_touch.png": 200,
	"./solutions/solution/logos/sensors.png": 201,
	"./solutions/solution/logos/shoppify.png": 202,
	"./solutions/solution/logos/sirikit.png": 203,
	"./solutions/solution/logos/sketch.png": 204,
	"./solutions/solution/logos/soap.png": 205,
	"./solutions/solution/logos/spring.png": 206,
	"./solutions/solution/logos/sql_server2014.png": 207,
	"./solutions/solution/logos/sqlite.png": 208,
	"./solutions/solution/logos/swift.png": 209,
	"./solutions/solution/logos/symfony.png": 210,
	"./solutions/solution/logos/theme_customization.png": 211,
	"./solutions/solution/logos/third-party_integrations.png": 212,
	"./solutions/solution/logos/touchid.png": 213,
	"./solutions/solution/logos/visual_studio.png": 214,
	"./solutions/solution/logos/visual_studio_2015.png": 215,
	"./solutions/solution/logos/wcf.png": 216,
	"./solutions/solution/logos/web_stress.png": 217,
	"./solutions/solution/logos/wireless.png": 218,
	"./solutions/solution/logos/woocommerce_theme_customization.png": 219,
	"./solutions/solution/logos/wordPress.png": 220,
	"./solutions/solution/logos/xamarian.png": 221,
	"./solutions/solution/logos/xamarin_for_visual_studio.png": 222,
	"./solutions/solution/logos/xamarin_forms.png": 223,
	"./solutions/solution/logos/xamarin_test_cloud.png": 224,
	"./solutions/solution/logos/xcode.png": 225,
	"./solutions/solution/logos/xml.png": 226,
	"./solutions/solution/logos/xmpp.png": 227,
	"./solutions/solution/logos/yii.png": 228,
	"./solutions/solution/logos/zend.png": 229,
	"./solutions/solution/logos/zoho.png": 230,
	"./solutions/solution/ondemand.jpg": 345,
	"./sprite.png": 646,
	"./startup.png": 647,
	"./startup/startUp.jpg": 648,
	"./testimonial.png": 421,
	"./uae.png": 649,
	"./uk.png": 650,
	"./uk.svg": 356,
	"./under-construction.svg": 510,
	"./us.svg": 355,
	"./usa.png": 651,
	"./whoweare/Conneightion.png": 360,
	"./whoweare/TRI.png": 361,
	"./whoweare/Telangana.PNG": 362,
	"./whoweare/airtel.png": 363,
	"./whoweare/ap.png": 364,
	"./whoweare/bgm.png": 365,
	"./whoweare/butterfly.png": 366,
	"./whoweare/crown.png": 367,
	"./whoweare/da.png": 368,
	"./whoweare/dell.png": 369,
	"./whoweare/dm.png": 370,
	"./whoweare/dorvenfoods.png": 371,
	"./whoweare/dorvenretail.png": 372,
	"./whoweare/dytronix.png": 373,
	"./whoweare/fb.png": 374,
	"./whoweare/fc.png": 375,
	"./whoweare/feedbellie.png": 376,
	"./whoweare/ffas.png": 377,
	"./whoweare/ghmc.png": 378,
	"./whoweare/goa.png": 379,
	"./whoweare/hp.png": 380,
	"./whoweare/hsf.png": 381,
	"./whoweare/janahitha.png": 382,
	"./whoweare/jbl.png": 383,
	"./whoweare/jd.png": 384,
	"./whoweare/jdesk.png": 385,
	"./whoweare/jds.png": 386,
	"./whoweare/kamlesh.png": 387,
	"./whoweare/kdrav.png": 388,
	"./whoweare/kdrf.png": 389,
	"./whoweare/kdrm.png": 390,
	"./whoweare/klubf5.png": 391,
	"./whoweare/leafent.png": 392,
	"./whoweare/mananagaram.png": 393,
	"./whoweare/manymore.png": 394,
	"./whoweare/nalgonda.png": 395,
	"./whoweare/nbb.png": 396,
	"./whoweare/nowl.png": 397,
	"./whoweare/paw.png": 398,
	"./whoweare/rsd.png": 399,
	"./whoweare/santos.png": 400,
	"./whoweare/shikara.png": 401,
	"./whoweare/srpt.png": 402,
	"./whoweare/startcareer.png": 403,
	"./whoweare/sunrisers.png": 404,
	"./whoweare/svmovie.png": 405,
	"./whoweare/talasha.png": 406,
	"./whoweare/teeksha.png": 407,
	"./whoweare/tfs.png": 408,
	"./whoweare/ting.png": 409,
	"./whoweare/tsforest.png": 410,
	"./whoweare/turtle.png": 411,
	"./whoweare/vanamali.png": 412,
	"./whoweare/veehaari.png": 413,
	"./whoweare/vertisoft.png": 414,
	"./whoweare/vh.png": 415,
	"./whoweare/vhcabs.png": 416,
	"./whoweare/vikram.png": 417,
	"./whoweare/wa.png": 418,
	"./why/Team/ai.png": 652,
	"./why/Team/augr.jpg": 653,
	"./why/Team/bcbg.jpg": 654,
	"./why/Team/ourteam.png": 655,
	"./why/awards/Razorpay.png": 656,
	"./why/awards/acquia-logo.png": 657,
	"./why/awards/amazon-part.png": 658,
	"./why/awards/apple-partner-logo.png": 659,
	"./why/awards/authorize-logo.png": 660,
	"./why/awards/cashfree_partner.png": 661,
	"./why/awards/clutch.png": 662,
	"./why/awards/drupal-logo.png": 663,
	"./why/awards/magestore-logo.png": 664,
	"./why/awards/microsoft-partner-logo.png": 665,
	"./why/awards/paypal-part.png": 666,
	"./why/awards/stripe-partner.jpg": 667
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 25;